import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public title = 'Icehorse Scheduling Assistant';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts